function addFigure (val) {
  if (Number.isNaN(val)) {
    return 0
  } else if (!val) {
    return val
  }
  val = val.toString()
  while (val !== (val = val.replace(/^(-?\d+)(\d{3})/, '$1,$2')));
  return val
}

export default addFigure



// WEBPACK FOOTER //
// ./src/misc/addFigure.js